import { render, staticRenderFns } from "./TrainingProviderLayout.vue?vue&type=template&id=51a81abc&"
import script from "./TrainingProviderLayout.vue?vue&type=script&lang=js&"
export * from "./TrainingProviderLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports